import http from "./http-common";

class EnumsDataService {
  getAllEnums() {
    return http.get("/utils/enums");
  }
}

export default new EnumsDataService();
